// @ts-strict-ignore
import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { DeviceUtils } from '../util/device-utils';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[maxHeightOffset]'
})
export class MaxHeightDirective implements OnInit, OnDestroy {

  @Input()
  public maxHeightOffset: number;

  private listener = () => {
    this.elementRef.nativeElement.style.maxHeight = `${+((+window.innerHeight) - (+this.maxHeightOffset))}px`;
  }

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    if (!this.maxHeightOffset) {
      this.maxHeightOffset = 180;
    }
    this.elementRef.nativeElement.style.overflowY = `auto`;
    this.elementRef.nativeElement.style.minHeight = `150px`;
    if (DeviceUtils.isTouch()) {
      this.listener();
      window.addEventListener(`resize`, this.listener);
    } else {
      this.elementRef.nativeElement.style.maxHeight = `calc(100vh - ${this.maxHeightOffset}px)`;
    }
  }

  ngOnDestroy(): void {
    if (DeviceUtils.isTouch()) {
      window.removeEventListener(`resize`, this.listener);
    }
  }
}
